export default "__VITE_ASSET__CCY0kOKy__"